/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './viewing-schedule-old.stache';
import FeedService from 'scripts/services/base-feed-service';
import dayjs from 'dayjs';
import _ from 'lodash';

const scheduleDatesUrl = window.globalSettings.feeds.schedule.scheduleDatesUrl;

Component.extend({
    tag: 'viewing-schedule-old',
    template,
    viewModel: {
        define: {
            scheduleDate: {
                type: 'string',
                value: null,
            },
            days: {
                type: 'array',
                value: [],
            },
            daysDelta: {
                type: 'number',
                value: 1,
            },
            broadcasts: {
                type: 'array',
                value: [],
            },
        },
        onTabChange(event) {
            const slideIndex = _.findIndex(this.days, [
                'key',
                event.payload.value,
            ]);
            this.attr('scheduleDate', event.payload.value);
            this.swiper.slideTo(slideIndex);
        },
    },
    events: {
        inserted() {
            this.getDates();
        },

        getDates() {
            new FeedService({
                feedUrl: scheduleDatesUrl,
                fromCache: false,
                autoUpdate: false,
            })
                .on('data', (type, data) => {
                    if (data && data.tags && data.tags.length) {
                        const days = data.tags.map((day) => {
                            return Object.assign({}, day, {
                                capitalized: day.title.toUpperCase(),
                            });
                        });

                        this.viewModel.attr('days', days);
                    }
                })
                .on('error', (error) => {
                    console.error('Error fetching schedule dates', error);
                })
                .fetch();
        },
    },
});
